import { render } from "./CertificatePage.vue?vue&type=template&id=aba971e2&scoped=true"
import script from "./CertificatePage.vue?vue&type=script&lang=js"
export * from "./CertificatePage.vue?vue&type=script&lang=js"

import "./CertificatePage.vue?vue&type=style&index=0&id=aba971e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aba971e2"]])

export default __exports__